<template lang="pug">
.position-relative
  .navigation
    .position-back
      .button.is-small(
        @click="$emit('prev')"
      )
        span.icon.is-small
          i.fa.fa-arrow-left
        span Previous step
  .step-title
    span Start mining!

  .feature-helvetica.step-explanation
    span You have finished!, you can now start mining, simply download the auto-generated .bat / .sh file and run it inside your miner files directory (depending on the miner you choose).

  .miners-container
    .miner(v-for="o in filteredMiners")
      .title-container
        .flex-1
          .title.is-6 {{ o.name }}
          .subtitle.is-6.mt-0 {{ o.description }}
      .pl-2
        .tabs.is-small.is-boxed.os-tabs
          ul
            li(:class="{'is-active': o.osSelected === 'windows'}" @click="o.osSelected = 'windows'")
              a 
                span.icon.is-small
                  i.fa.fa-windows
                span Windows
            li(:class="{'is-active': o.osSelected === 'linux'}" @click="o.osSelected = 'linux'")
              a 
                span.icon.is-small
                  i.fa.fa-linux
                span Linux
        .command
          pre
            span {{ fullComand(o) }}
          button.button.right(@click="copyToClipboard(fullComand(o))") 
            i.fa.fa-clipboard
            span Copy
        .button-down-container
          a.button.button-down.is-info(@click="downloadBatFile(o, fullComand(o))", href="#") 
            span.mr-5 Download 
            span.mr-5 .{{ o[o.osSelected + 'DownloadFileExtension'] }} 
            span file
            i.fa.fa-download
          a.button.button-down.button-default(:href="o.urlDocumentation", target="_blank")
            span Official documentation
            i.fa.fa-external-link
          a.button.button-down.button-default(:href="o.urlDownload", target="_blank")
            span Download miner files
            i.fa.fa-external-link
        div.subtitle.is-7.mt-10.has-text-centered
          .mb-5
            span Be sure to check our support article for more details on 
            a.info-link(:href="o.urlSupportArticle", target="_blank") how to configure {{ o.name }}.
          .mb-5
            span Learn how to fix the restrictions 
            a.info-link(href="/support/article/how-to-execute-our-downloadable-bat-file", target="_blank") when downloading or running a bat file on Windows.
          .mb-5
            span Learn how to 
            a.info-link(href="/support/article/how-to-create-a-bat-file", target="_blank") create a .bat (batch) file

  hr

  .step-title
    span Let the monitoring begins

  .feature-helvetica.step-explanation
    p.mr-5 After you start mining (5 minutes aproximately), you will be able to see your stats on the website, along with your current balance, past payouts and more:
    .is-flex.jcc.aic.mt-20
      .button-stats-container
        a.button.button-stats.is-info(:href="'/address/' + address + '?coin=' + coin.symbol", target="_blank") 
          span.mr-5 See your stats
          i.fa.fa-line-chart
</template>

<script>
export default {
  name: 'c_step_final',
  props: ['mode', 'miningType', 'algorithm', 'coin', 'address', 'region', 'port', 'worker', 'referralCode'],
  data() {
    return {

      miners: [
        {
          code: 'nbminer',
          name: 'NBMiner',
          description: 'NVIDIA + AMD GPU Miner',
          osSelected: 'windows',
          windowsProgram: 'nbminer.exe',
          linuxProgram: './nbminer',
          windowsDownloadFileExtension: 'bat',
          linuxDownloadFileExtension: 'sh',
          poolFlag: '-o',
          walletFlag: '-u',
          algorithmFlag: '-a',
          otherFlags: '-log',
          sslCommand: '',
          commandType: 'normal',
          urlDocumentation: 'https://github.com/NebuTech/NBMiner#cmd-options',
          urlDownload: 'https://github.com/NebuTech/NBMiner/releases',
          urlSupportArticle: 'https://unmineable.com/support/article/how-to-setup-nbminer-for-gpu-mining',
          algorithms: [
            { code: 'ethash', command: 'ethash' },
            { code: 'etchash', command: 'etchash' },
            { code: 'kawpow', command: 'kawpow' },
            { code: 'autolykos', command: 'ergo' },
            { code: 'beamhash', command: 'beamv3' },
            { code: 'octopus', command: 'octopus' }
          ]
        },
        {
          code: 'gminer',
          name: 'GMiner',
          description: 'NVIDIA + AMD GPU Miner',
          osSelected: 'windows',
          windowsProgram: 'miner.exe',
          linuxProgram: './miner',
          windowsDownloadFileExtension: 'bat',
          linuxDownloadFileExtension: 'sh',
          poolFlag: '-s',
          walletFlag: '-u',
          algorithmFlag: '-a',
          otherFlags: '',
          sslCommand: '',
          commandType: 'normal',
          urlDocumentation: 'https://bitcointalk.org/index.php?topic=5034735',
          urlDownload: 'https://github.com/develsoftware/GMinerRelease/releases',
          urlSupportArticle: 'https://unmineable.com/support/article/how-to-setup-gminer-for-gpu-mining',
          algorithms: [
            { code: 'ethash', command: 'ethash' },
            { code: 'etchash', command: 'etchash' },
            { code: 'kawpow', command: 'kawpow' },
            { code: 'zelhash', command: 'equihash125_4' },
            { code: 'octopus', command: 'octopus' }
          ]
        },
        {
          code: 'teamredminer',
          name: 'Team Red Miner',
          description: 'AMD GPU Miner',
          osSelected: 'windows',
          windowsProgram: 'teamredminer.exe',
          linuxProgram: './teamredminer',
          windowsDownloadFileExtension: 'bat',
          linuxDownloadFileExtension: 'sh',
          poolFlag: '-o',
          walletFlag: '-u',
          algorithmFlag: '-a',
          otherFlags: '',
          sslCommand: '',
          commandType: 'normal',
          urlDocumentation: 'https://github.com/todxx/teamredminer/blob/master/USAGE.txt',
          urlDownload: 'https://github.com/todxx/teamredminer/releases',
          urlSupportArticle: 'https://unmineable.com/support/article/how-to-setup-teamredminer-for-gpu-mining',
          algorithms: [
            { code: 'ethash', command: 'ethash' },
            { code: 'etchash', command: 'etchash' },
            { code: 'kawpow', command: 'kawpow' },
            { code: 'autolykos', command: 'autolykos2' }
          ]
        },
        {
          code: 'xmrig',
          name: 'Xmrig',
          description: 'CPU Miner',
          osSelected: 'windows',
          windowsProgram: 'xmrig.exe',
          linuxProgram: './xmrig',
          windowsDownloadFileExtension: 'bat',
          linuxDownloadFileExtension: 'sh',
          poolFlag: '-o',
          walletFlag: '-u',
          algorithmFlag: '-a',
          otherFlags: '-p x',
          sslCommand: '',
          commandType: 'normal',
          urlDocumentation: 'https://xmrig.com/docs/miner/command-line-options',
          urlDownload: 'https://github.com/xmrig/xmrig/releases',
          urlSupportArticle: 'https://unmineable.com/support/article/how-to-setup-xmrig-for-cpu-mining',
          algorithms: [
            { code: 'randomx', command: 'rx' },
            { code: 'ghostrider', command: 'gr' }
          ]
        },
        {
          code: 't-rex',
          name: 'T-Rex',
          description: 'NVIDIA GPU Miner',
          osSelected: 'windows',
          windowsProgram: 't-rex.exe',
          linuxProgram: './t-rex',
          windowsDownloadFileExtension: 'bat',
          linuxDownloadFileExtension: 'sh',
          poolFlag: '-o',
          walletFlag: '-u',
          algorithmFlag: '-a',
          otherFlags: '-p x',
          sslCommand: '--no-strict-ssl',
          commandType: 'normal',
          urlDocumentation: 'https://github.com/trexminer/T-Rex',
          urlDownload: 'https://github.com/trexminer/T-Rex/releases',
          urlSupportArticle: 'https://unmineable.com/support/article/how-to-setup-t-rex-for-gpu-mining',
          algorithms: [
            { code: 'ethash', command: 'ethash' },
            { code: 'etchash', command: 'etchash' },
            { code: 'kawpow', command: 'kawpow' },
            { code: 'autolykos', command: 'autolykos2' },
            { code: 'blake3', command: 'blake3' },
            { code: 'octopus', command: 'octopus' }
          ]
        },
        {
          code: 'lolminer',
          name: 'lolMiner',
          description: 'NVIDIA + AMD GPU Miner',
          osSelected: 'windows',
          windowsProgram: 'lolMiner.exe',
          linuxProgram: './lolMiner',
          windowsDownloadFileExtension: 'bat',
          linuxDownloadFileExtension: 'sh',
          poolFlag: '--pool',
          walletFlag: '--user',
          algorithmFlag: '--algo',
          otherFlags: '',
          sslCommand: '',
          commandType: 'normal',
          urlDocumentation: 'https://github.com/Lolliedieb/lolMiner-releases',
          urlDownload: 'https://github.com/Lolliedieb/lolMiner-releases/releases',
          urlSupportArticle: 'https://unmineable.com/support/article/how-to-setup-lolminer-for-gpu-mining',
          algorithms: [
            { code: 'ethash', command: 'ETHASH --ethstratum ETHPROXY' },
            { code: 'etchash', command: 'ETCHASH --ethstratum ETHPROXY' },
            { code: 'autolykos', command: 'AUTOLYKOS2' },
            { code: 'beamhash', command: 'BEAM-III' },
            { code: 'zelhash', command: 'ZEL --pers AUTO' },
            { code: 'blake3', command: 'ALEPH' },
            { code: 'fishhash', command: 'FISHHASH' },
            { code: 'nexapow', command: 'NEXA' },
            { code: 'karlsenhash', command: 'KARLSENV2' }
          ]
        },
        {
          code: 'miniz',
          name: 'miniZ',
          description: 'NVIDIA + AMD GPU Miner',
          osSelected: 'windows',
          windowsProgram: 'miniZ.exe',
          linuxProgram: './miniZ',
          windowsDownloadFileExtension: 'bat',
          linuxDownloadFileExtension: 'sh',
          poolWalletFlag: '--url',
          algorithmFlag: '--par',
          otherFlags: '--log --extra',
          sslCommand: '',
          commandType: 'miniz',
          urlDocumentation: 'https://miniz.cc/usage',
          urlDownload: 'https://miniz.cc/download',
          urlSupportArticle: 'https://unmineable.com/support/article/how-to-setup-miniz-for-gpu-mining',
          algorithms: [
            { code: 'ethash', command: 'ethash' },
            { code: 'etchash', command: 'etchash --pers etchash' },
            { code: 'kawpow', command: 'kawpow --pers rAVENCOINKAWPOW' },
            { code: 'beamhash', command: 'beam3 --pers Beam-PoW' },
            { code: 'zelhash', command: '125,4 --pers ZelProof' }
          ]
        },
        {
          code: 'bminer',
          name: 'BMiner',
          description: 'NVIDIA + AMD GPU Miner',
          osSelected: 'windows',
          windowsProgram: 'bminer.exe',
          linuxProgram: './bminer',
          windowsDownloadFileExtension: 'bat',
          linuxDownloadFileExtension: 'sh',
          poolWalletAlgorithmFlag: '-uri',
          otherFlags: '',
          sslCommand: '',
          commandType: 'bminer',
          urlDocumentation: 'https://www.bminer.me/references/',
          urlDownload: 'https://www.bminer.me/releases/',
          urlSupportArticle: 'https://unmineable.com/support/article/how-to-setup-bminer-for-gpu-mining',
          algorithms: [
            { code: 'ethash', command: 'ethstratum' },
            { code: 'beamhash', command: 'beam' },
            { code: 'octopus', command: 'conflux' }
          ]
        },
        {
          code: 'srbminer',
          name: 'SRBMiner-MULTI',
          description: 'NVIDIA + AMD GPU and CPU Miner',
          osSelected: 'windows',
          windowsProgram: 'SRBMiner-MULTI.exe',
          linuxProgram: './SRBMiner-MULTI',
          windowsDownloadFileExtension: 'bat',
          linuxDownloadFileExtension: 'sh',
          poolFlag: '--pool',
          walletFlag: '--wallet',
          algorithmFlag: '--algorithm',
          otherFlags: '',
          sslCommand: '',
          commandType: 'normal',
          urlDocumentation: 'https://bitcointalk.org/index.php?topic=5190081.0',
          urlDownload: 'https://github.com/doktor83/SRBMiner-Multi/releases',
          urlSupportArticle: 'https://unmineable.com/support/article/how-to-setup-srbminer-for-gpu-mining',
          algorithms: [
            { code: 'ethash', command: 'ethash --disable-cpu' },
            { code: 'etchash', command: 'etchash --disable-cpu' },
            { code: 'kawpow', command: 'kawpow --disable-cpu' },
            { code: 'autolykos', command: 'autolykos2 --disable-cpu' },
            { code: 'blake3', command: 'blake3_alephium --disable-cpu' },
            { code: 'fishhash', command: 'fishhash --disable-cpu' },
            { code: 'xelishash', command: 'xelishashv2 --disable-cpu' },
            { code: 'randomx', command: 'randomx' },
            { code: 'ghostrider', command: 'ghostrider' },
            { code: 'karlsenhash', command: 'karlsenhashv2 --disable-cpu' }
          ]
        },
        {
          code: 'bzminer',
          name: 'BzMiner',
          description: 'NVIDIA + AMD GPU Miner',
          osSelected: 'windows',
          windowsProgram: 'bzminer.exe',
          linuxProgram: './bzminer',
          windowsDownloadFileExtension: 'bat',
          linuxDownloadFileExtension: 'sh',
          poolFlag: '-p',
          walletFlag: '-w',
          algorithmFlag: '-a',
          otherFlags: '',
          sslCommand: '',
          commandType: 'normal',
          urlDocumentation: 'https://github.com/bzminer/bzminer',
          urlDownload: 'https://github.com/bzminer/bzminer/releases',
          urlSupportArticle: 'https://unmineable.com/support/article/how-to-setup-bzminer-for-gpu-mining',
          algorithms: [
            { code: 'ethash', command: 'ethw' },
            { code: 'kawpow', command: 'rvn' },
            { code: 'blake3', command: 'alph' },
            { code: 'nexapow', command: 'nexa' }
          ]
        },
        {
          code: 'rigel',
          name: 'Rigel',
          description: 'NVIDIA GPU Miner',
          osSelected: 'windows',
          windowsProgram: 'rigel.exe',
          linuxProgram: './rigel',
          windowsDownloadFileExtension: 'bat',
          linuxDownloadFileExtension: 'sh',
          poolFlag: '-o',
          walletFlag: '-u',
          algorithmFlag: '-a',
          otherFlags: '',
          sslCommand: '--no-strict-ssl',
          commandType: 'normal',
          urlDocumentation: 'https://github.com/rigelminer/rigel',
          urlDownload: 'https://github.com/rigelminer/rigel/releases',
          urlSupportArticle: 'https://unmineable.com/support/article/how-to-setup-rigel-for-gpu-mining',
          algorithms: [
            { code: 'blake3', command: 'alephium' },
            { code: 'fishhash', command: 'fishhash' },
            { code: 'autolykos', command: 'autolykos2' },
            { code: 'nexapow', command: 'nexapow' },
            { code: 'karlsenhash', command: 'karlsenhashv2' },
            { code: 'xelishash', command: 'xelishashv2' }
          ]
        },
        {
          code: 'phoenixminer',
          name: 'PhoenixMiner',
          description: 'NVIDIA + AMD GPU Miner',
          osSelected: 'windows',
          windowsProgram: 'PhoenixMiner.exe',
          linuxProgram: './PhoenixMiner',
          windowsDownloadFileExtension: 'bat',
          linuxDownloadFileExtension: 'sh',
          poolFlag: '-pool',
          walletFlag: '-wal',
          algorithmFlag: '-coin',
          otherFlags: '-pass x',
          sslCommand: '-weakssl',
          commandType: 'normal',
          urlDocumentation: 'https://bitcointalk.org/index.php?topic=2647654.0',
          urlDownload: 'https://phoenixminer.info/downloads/',
          urlSupportArticle: 'https://unmineable.com/support/article/how-to-setup-phoenixminer-for-gpu-mining',
          algorithms: [
            { code: 'etchash', command: 'etc' }
          ]
        },
        {
          code: 'onezerominer',
          name: 'OneZeroMiner',
          description: 'NVIDIA GPU Miner',
          osSelected: 'windows',
          windowsProgram: 'onezerominer.exe',
          linuxProgram: './onezerominer',
          windowsDownloadFileExtension: 'bat',
          linuxDownloadFileExtension: 'sh',
          poolFlag: '-o',
          walletFlag: '-w',
          algorithmFlag: '-a',
          otherFlags: '',
          sslCommand: '--no-cert-validation',
          commandType: 'normal',
          urlDocumentation: 'https://github.com/OneZeroMiner/onezerominer',
          urlDownload: 'https://github.com/OneZeroMiner/onezerominer/releases',
          urlSupportArticle: 'https://unmineable.com/support/article/how-to-setup-onezerominer-for-gpu-mining',
          algorithms: [
            { code: 'xelishash', command: 'xelis', workerParam: '-p' }
          ]
        }
      ]
    }
  },
  computed: {
    filteredMiners() {
      let vm = this

      let filteredMiners = []

      for (var i = 0; i < vm.miners.length; i++) {
        let miner = vm.miners[i]
        for (var j = 0; j < miner.algorithms.length; j++) {
          let algorithm = miner.algorithms[j]
          if (algorithm.code === vm.algorithm.code) {
            filteredMiners.push(miner)
          }
        }
      }

      return filteredMiners
    }
  },
  mounted() {
    document.getElementById('step').scrollIntoView();
  },
  methods: {
    algorithmCommand(o) {
      let vm = this
      let algorithm = (o.algorithms.filter(a => a.code === vm.algorithm.code))[0]
      return algorithm.command
    },
    poolCommand(o) {
      let vm = this
      let protocol = 'stratum+tcp://'
      if (vm.port.ssl) protocol = 'stratum+ssl://'

      if (o.code === 'gminer') {
        protocol = 'proxy+tcp://'
        if (vm.port.ssl) protocol = 'proxy+ssl://'
      }

      if (o.commandType === 'miniz') {
        protocol = ''
      }

      if (o.commandType === 'bminer') {
        protocol = ''
      }

      let url = vm.region.url

      let port = vm.port.number

      return protocol + url + ':' + port
    },
    walletString(o) {
      let vm = this
      // Get the algorithm
      let coin = vm.coin.symbol
      let address = vm.address
      let worker = vm.worker
      let referralCode = vm.referralCode

      let algorithm = (o.algorithms.filter(a => a.code === vm.algorithm.code))[0]
      let walletString = ''

      if (algorithm.workerParam) {
        walletString = coin + ':' + address
        if (referralCode) {
          walletString += '#' + referralCode
        }
        walletString += ` ${algorithm.workerParam} ${worker}`
      } else {
        walletString = coin + ':' + address + '.' + worker
        if (referralCode) {
          walletString += '#' + referralCode
        }
      }

      return walletString
    },
    fullComand(o) {
      let vm = this
      let sslCommand = ''
      if (vm.port.ssl) {
        sslCommand = o.sslCommand
      }

      let finalPauseAppend = '\npause'
      if (o.osSelected === 'linux') finalPauseAppend = ''

      let command = ''
      let sslString = ''

      if (o.commandType === 'normal') {
        command = `${o[o.osSelected + 'Program']} ${o.algorithmFlag} ${vm.algorithmCommand(o)} ${o.poolFlag} ${vm.poolCommand(o)} ${o.walletFlag} ${vm.walletString(o)} ${o.otherFlags} ${sslCommand}${finalPauseAppend}`
      } else if (o.commandType === 'miniz') {
        if (vm.port.ssl) sslString = 'ssl://'
        command = `${o[o.osSelected + 'Program']} ${o.algorithmFlag} ${vm.algorithmCommand(o)} ${o.poolWalletFlag} ${sslString}${vm.walletString(o)}@${vm.poolCommand(o)} ${o.otherFlags} ${sslCommand}${finalPauseAppend}`
      } else if (o.commandType === 'bminer') {
        if (vm.port.ssl) sslString = '+ssl://'
        else sslString = '://'
        // We need to change the first ':' to '%%3A'
        let walletString = vm.walletString(o)
        walletString = walletString.replace(/:/, '%%3A')

        walletString = walletString.replace(/#/, '%%23')

        command = `${o[o.osSelected + 'Program']} ${o.poolWalletAlgorithmFlag} ${vm.algorithmCommand(o)}${sslString}${walletString}@${vm.poolCommand(o)} ${o.otherFlags} ${sslCommand}${finalPauseAppend}`
      } else {
        // Same as normal
        command = `${o[o.osSelected + 'Program']} ${o.algorithmFlag} ${vm.algorithmCommand(o)} ${o.poolFlag} ${vm.poolCommand(o)} ${o.walletFlag} ${vm.walletString(o)} ${o.otherFlags} ${sslCommand}${finalPauseAppend}`
      }

      return command
    },
    copyToClipboard(text) {
      let vm = this
      const clipboardData = event.clipboardData || window.clipboardData || navigator.clipboard;
      clipboardData.writeText(text);
      vm.$store.dispatch('notifySuccess', 'Text copied!')
    },
    downloadBatFile(o, text) {
      let vm = this
      const element = document.createElement('a');
      const file = new Blob([text], {
        type: 'text/plain'
      });
      element.href = URL.createObjectURL(file);
      element.download = `unmineable-${vm.coin.symbol}-${vm.algorithm.code}-${o.code}.${o[o.osSelected + 'DownloadFileExtension']}`;
      document.body.appendChild(element);
      element.click();
    }
  }
}
</script>

<style lang="stylus">
.miners-container
  margin-bottom 20px
  max-width calc(1080px - 276px)
.miner
  text-align left
  margin-top 20px
  .title-container
    display flex
    align-items center
    margin 10px 0px
    .title
      margin-bottom 0px
    .subtitle
      margin-top 2px
    a
      font-size 20px
      color #363636
  pre
    font-size 16px
    white-space: pre-wrap
    word-wrap: break-word
    padding-bottom: 45px;
    /* max-width: calc(100vw - 48px); */

  .command
    position relative
    button.left
      position absolute
      left 0px
      bottom 0px
      background-color: #b6ffb6;
      border 0px
      border-radius 0px
      &:hover
        background-color #77ff77
      i
        margin-right 5px
        
    button.right
      position absolute
      right 0px
      bottom 0px
      background-color: #b6ffb6;
      border 0px
      border-radius 0px
      &:hover
        background-color #77ff77
      i
        margin-right 5px
  
  .button-down-container
    display flex
    justify-content: space-between;
    flex-wrap wrap
    .button-down
      width 32%
      margin-top 12px
      font-weight 400
      font-size 16px
      font-family: 'Poppins';
      i
        margin-left 5px

.os-tabs
  margin-bottom: 0px !important;
  .is-active
    a
      font-weight 400
      background-color: #f5f5f5 !important;

.button-stats-container
    display flex
    justify-content: space-between;
    flex-wrap wrap
    .button-stats
      font-weight 400
      font-size 16px
      font-family: 'Poppins';
      i
        margin-left 5px
html.dark, body.dark
  .button-down-container
    .button-default
      color: #363636;     
  .os-tabs
    border-color #4a4a4a
    .is-active
      a
        background-color: #f5f5f5 !important;
        color #4a4a4a !important;


@media (max-width: 1279px)
  .miners-container
    max-width: calc(960px - 246px)
  .miner
    .button-down-container
      .button-down
        width 49%
        &.is-info
          width 100%

@media (max-width: 1030px)
  .miners-container
    max-width: calc(100vw - 246px - 40px)

@media (max-width: 768px)
  .miners-container
    max-width: calc(100vw - 63px)

@media (max-width: 495px)
  .miner
    .button-down-container
      flex-direction column
      .button-down
        width 100%
      
@media (max-width: 351px)
  .miner
    pre
      max-width: calc(100vw);

</style>



// WEBPACK FOOTER //
// c_step_final.vue?18fab0ac